import { queryOptions } from '@tanstack/react-query'
import { apiGet, unwrap } from '@/shared/api'
import type { FocusSession } from '../model/schema'
import { type FocusSessionDto, toFocusSession } from './mappers'

export const focusKeys = {
  all: ['focus'] as const,
  me: () => [...focusKeys.all, 'me'] as const,
  active: () => [...focusKeys.all, 'active'] as const,
}

// Моя running focus-сессия или null (не в фокусе). Меняется моими мутациями
// (enter/exit), не поллится.
export const focusMeQueryOptions = queryOptions({
  queryKey: focusKeys.me(),
  queryFn: async (): Promise<FocusSession | null> => {
    const dto = unwrap<FocusSessionDto | null>(await apiGet('/focus/me'))
    return dto ? toFocusSession(dto) : null
  },
})

// Кто сейчас в фокусе (presence «не беспокоить»). Поллинг 60с — единственный
// источник живости presence без websocket (docs/design/README.md §4).
export const focusActiveQueryOptions = queryOptions({
  queryKey: focusKeys.active(),
  queryFn: async (): Promise<FocusSession[]> => {
    const list = unwrap<FocusSessionDto[]>(await apiGet('/focus/active')) ?? []
    return list.map(toFocusSession)
  },
  refetchInterval: 60_000,
})
